import { SUBMIT_ORDER_DETAILS_PAGE_ACTION_NAME } from '../constants/scanActionNames.const';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';

export const createSubmitOrderDetailsPageScanAction = (): ScanAction => ({
  // TODO: QPACK-506: Implement the logic to submit the order details drawer.
  execute: (scanEvent: ScanEvent): ScanActionResult => {
    // eslint-disable-next-line no-console
    console.debug('Executed Action: SubmitOrderDetailsPageScanAction', scanEvent);
    return { success: true };
  },

  // TODO: QPACK-506: Implement the logic to submit the order details drawer.
  matches: () => false,

  name: SUBMIT_ORDER_DETAILS_PAGE_ACTION_NAME,
});
